import React from "react";
import { FullRow, Row, Col } from "../../framework/Grid";
import AcquireWebComponent from "../../framework/MaterialUI";
import AudInputField from "../../framework/InputField/InputField";
import { RaisedButton } from "material-ui";
import { isEmpty } from "lodash";
import "../auth.css";
import { uiBuildNumber } from "../../../env";
import { URL } from "url-polyfill/url";

class ChangePassword extends AcquireWebComponent {
  updateDimensions() {
    this.setState({
      height: window.innerHeight + "px",
      topPadding: (window.innerHeight - 480) / 2 + "px",
      footerTop: (window.innerHeight - 480) / 2 - 20 + "px",
    });
  }

  retrieveSession(session) {
    this.session = JSON.parse(session);
  }

  componentWillMount() {
    this.updateDimensions();
    this.setState({
      password: "",
      password2: "",
    });
  }

  componentDidMount() {
    const url = new URL(window.location.href);
    const reqKey =
      url && url.searchParams
        ? url.searchParams.get("requestKey")
        : url.search.replace("?requestKey=", "");
    this.setState({
      requestKey: reqKey,
    });
    window.addEventListener("resize", this.updateDimensions.bind(this));
    if (!this.props.apiBuildNumber) {
      this.props.getAPIBuildNumber();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  handlePasswordChanged(e, value) {
    this.setState({
      password: value,
    });
  }

  handlePasswordKeyPress(e) {
    if (e.key === "Enter") {
      if (!isEmpty(this.state.password))
        this.passwordReInput.refs.inputRef.focus();
    }
  }

  handlePasswordReEnterChanged(e, value) {
    this.setState({
      password2: value,
    });

    if (value !== this.state.password) {
      this.setState({
        password2Tooltip: "Password and confirm must be equal.",
      });
      setTimeout(
        function() {
          this.passwordInput.refs.inputRef.focus();
          this.passwordReInput.refs.inputRef.focus();
        }.bind(this),
        20,
      );
    } else {
      this.setState({
        password2Tooltip: undefined,
      });
    }
  }

  handlePasswordReEnterKeyPress(e) {
    if (e.key === "Enter") {
      this.btnSubmit.refs.container.button.focus();
      this.props.resetPassword(
        this.state.password,
        this.state.password2,
        this.state.requestKey,
      );
    }
  }

  clickContinue(e) {
    e.preventDefault();
    this.props.resetPassword(
      this.state.password,
      this.state.password2,
      this.state.requestKey,
    );
  }

  render() {
    const { apiBuildNumber } = this.props;
    const { resetPasswordSuccess, resetPasswordFailMessage } = this.props;
    const hasErrorMessage =
      resetPasswordFailMessage !== undefined && resetPasswordSuccess !== true;
    return (
      <Row
        className="login-container"
        style={{ height: this.state.height, paddingTop: this.state.topPadding }}
      >
        <Col
          xs="4"
          sm="4"
          md="4"
          lg="4"
          offsetXs="4"
          offsetSm="4"
          offsetLg="4"
          offsetMd="4"
        >
          <FullRow className="text-center" style={{ marginBottom: "-30px" }}>
            <img
              alt=""
              src="/aa.png"
              style={{
                display: "inline-table",
                marginTop: "-12px",
                marginRight: "10px",
                height: "36px",
              }}
            />
            <span
              style={{
                display: "inline-table",
                letterSpacing: "1.5pt",
                fontSize: "22pt",
                fontWeight: "600",
              }}
            >
              AudienceAnywhere
            </span>
          </FullRow>
          <FullRow className="text-center">
            <div
              key="send-reset-success"
              className="login-form"
              style={{
                display: resetPasswordSuccess === true ? "block" : "none",
                color: "#000",
              }}
            >
              <div style={{ marginTop: "30px", fontSize: "12pt" }}>
                {" "}
                PASSWORD CHANGED
              </div>
              <div style={{ marginTop: "30px", marginBottom: "30px" }}>
                {" "}
                Success! Your Password has been changed!
              </div>
              <hr style={{ color: "#000" }} />
              <div className="text-right">
                <a className="link-with-white" href="/login">
                  Back to log in
                </a>
                &nbsp;|&nbsp;
                <a
                  className="link-with-white"
                  href="mailto:AudienceAnywhere@claritas.com"
                >
                  Contact{" "}
                </a>
              </div>
            </div>
            <div
              key="send-reset-form"
              className="login-form"
              style={{
                display: resetPasswordSuccess !== true ? "block" : "none",
              }}
            >
              <div className="text-left " style={{ color: "#000" }}>
                <h3>Choose a new password</h3>
              </div>
              <div
                style={{ display: hasErrorMessage ? "block" : "none" }}
                className="error-message-box"
              >
                <div style={{ color: "red" }}>{resetPasswordFailMessage}</div>
              </div>
              <div style={{ color: "#000" }} className="text-left mb-10">
                Enter new password
              </div>
              <AudInputField
                ref={input => {
                  this.passwordInput = input;
                }}
                labelTitle=""
                key="passwordInputField"
                toolTipContent={this.state.passwordTooltip}
                onChange={(e, value) => this.handlePasswordChanged(e, value)}
                initValue={this.state.password}
                hintText="Enter your password"
                inputType="password"
                onKeyDown={e => this.handlePasswordKeyPress(e)}
              />
              <div style={{ color: "#000" }} className="text-left mb-10">
                Re-enter password
              </div>
              <AudInputField
                ref={input => {
                  this.passwordReInput = input;
                }}
                labelTitle=""
                key="passwordReInputField"
                toolTipContent={this.state.password2Tooltip}
                onChange={(e, value) =>
                  this.handlePasswordReEnterChanged(e, value)
                }
                initValue={this.state.password2}
                hintText="Re-enter your password"
                inputType="password"
                onKeyDown={e => this.handlePasswordReEnterKeyPress(e)}
              />
              <RaisedButton
                backgroundColor={"#F56600"}
                ref={input => {
                  this.btnSubmit = input;
                }}
                labelColor="#FFF"
                key="btn-continue"
                disabled={
                  isEmpty(this.state.password) ||
                  isEmpty(this.state.password2) ||
                  this.state.password !== this.state.password2
                }
                style={{ marginTop: "20px" }}
                onClick={this.clickContinue.bind(this)}
                label="CONTINUE"
              />
              <hr style={{ color: "#000" }} />
              <div className="text-right">
                <a className="link-with-white" href="/login">
                  Back to log in
                </a>
                &nbsp;|&nbsp;
                <a
                  className="link-with-white"
                  href="mailto:AudienceAnywhere@claritas.com"
                >
                  Contact{" "}
                </a>
              </div>
            </div>
          </FullRow>
          <div className="text-center" style={{ color: "#FFFFFF" }}>
            <a
              className="link-color-white"
              target="_blank"
              href="https://www.claritas.com/sites/default/files/files/Claritas%20Comprehensive%20Privacy%20Policy%20-%20Jan%202019.pdf"
            >
              Privacy Policy
            </a>{" "}
            - <span className="link-color-white">Terms of use</span>
          </div>
        </Col>
        <Col xs="12" sm="12" md="12" lg="12">
          {uiBuildNumber && apiBuildNumber && (
            <span
              className="pull-right text-right"
              style={{
                fontSize: "0.6em",
                position: "absolute",
                right: "0",
                top: this.state.footerTop,
              }}
            >
              <small>UI Build #{uiBuildNumber}</small>
              <br />
              <small>API Build #{apiBuildNumber}</small>
            </span>
          )}
        </Col>
      </Row>
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/Auth/ChangePassword/index.jsx